import styled from "styled-components";

export const Wrapper = styled.div<{ $visible: boolean }>`
  display: flex;
  gap: 2px;

  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
`;

export const Dot = styled.div<{ $i: number }>`
  width: 14px;
  height: 14px;
  border-radius: 25%;
  animation: dot 1.2s infinite ease-in-out both;
  animation-delay: ${({ $i }) => ($i - 1) * 0.2}s;
  background-color: ${(p) => p.theme.loader.dotColor};

  @keyframes dot {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(0.5);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
